import {Dimensions} from 'react-native';
import i18n from 'i18n-js';

export const getNextAccessLevel = currentLevel => {
  const levels = ['always_on', 'optional', 'disabled'];
  const currentIndex = levels.indexOf(currentLevel);
  const nextIndex = (currentIndex + 1) % levels.length;
  return levels[nextIndex];
};

export const getAccessLevelLabel = level => {
  const labels = {
    always_on: i18n.t('zoneAccess.alwaysOn'),
    optional: i18n.t('zoneAccess.optional'),
    disabled: i18n.t('zoneAccess.disabled')
  };
  return labels[level] || level;
};

export const getAccessLevelGradient = level => {
  const gradients = {
    always_on: ['#69efb5', '#23c07c'],
    optional: ['#f9af34', '#d7850f'],
    disabled: ['#d61101', '#960100']
  };
  return gradients[level] || ['#757575', '#757575'];
};

export const getAccessLevelBorderColor = level => {
  const borderColors = {
    always_on: '#23c07c',
    optional: '#d7850f',
    disabled: '#960100'
  };
  return borderColors[level] || '#757575';
};

export const getTooltipLeft = (iconPosition, tooltipWidth = 300, screenWidth = null) => {
  const screenW = screenWidth || Dimensions.get('window').width;
  const iconCenterX = iconPosition.centerX || 0;
  const left = iconCenterX - tooltipWidth / 2;
  return Math.max(10, Math.min(left, screenW - tooltipWidth - 10));
};

export const getTooltipTop = iconPosition => {
  return iconPosition.y + 10;
};

export const getTooltipArrowLeft = (iconPosition, tooltipWidth = 300, screenWidth = null) => {
  if (!iconPosition.centerX || !iconPosition.x) return '48%';
  const tooltipLeft = getTooltipLeft(iconPosition, tooltipWidth, screenWidth);
  const iconCenterX = iconPosition.centerX;
  const arrowOffset = iconCenterX - tooltipLeft;
  const percentage = (arrowOffset / tooltipWidth) * 100 - 3;
  return `${Math.max(10, Math.min(90, percentage))}%`;
};

export const extractUniqueZones = accesses => {
  const zonesFromAccesses = (accesses || []).map(access => access.zone).filter(zone => zone != null);
  const uniqueZones = zonesFromAccesses.reduce((acc, zone) => {
    const existingZone = acc.find(z => {
      if (zone.id === null && z.id === null) return true;
      if (zone.id === null || z.id === null) return false;
      return z.id === zone.id;
    });
    if (!existingZone) {
      acc.push(zone);
    }
    return acc;
  }, []);
  return uniqueZones;
};

export const prepareScanPackSettingsPayload = (scanPackSettings, newZoneAccessSource) => {
  let actualSettings = scanPackSettings;
  if (scanPackSettings.data && typeof scanPackSettings.data === 'object') {
    actualSettings = scanPackSettings.data;
  }
  const payload = {...actualSettings};
  if (payload.settings && typeof payload.settings === 'object') {
    const {zone_access_source: _, ...nestedSettings} = payload.settings;
    Object.assign(payload, nestedSettings);
    delete payload.settings;
  }
  payload.zone_access_source = newZoneAccessSource;
  return payload;
};

export const getToggledZoneAccessSource = currentSource => {
  return currentSource === 'cart' ? 'user' : 'cart';
};

export const measureIconPosition = (iconRef, callback) => {
  if (iconRef && iconRef.current) {
    iconRef.current.measureInWindow((x, y, width, height) => {
      const centerX = x + width / 2;
      const position = {x, y: y + height, width, centerX};
      if (callback) {
        callback(position);
      }
    });
  }
};
